import * as Sentry from "@sentry/react";
import { ClientErrorTypes } from "globals/enums";

function toError(e: unknown): Error {
  if (e instanceof Error) return e;
  if (typeof e === "string") return new Error(e);
  if (e !== null && e !== undefined && typeof e === "object") {
    try {
      const obj = e as { message?: unknown; error?: unknown };
      if (typeof obj.message === "string") return new Error(obj.message);
      if (typeof obj.error === "string") return new Error(obj.error);
      return new Error(JSON.stringify(e));
    } catch {
      return new Error("Unable to serialize error");
    }
  }
  return new Error(String(e ?? "Unknown error"));
}

export function handleError(
  e: unknown,
  source?: ClientErrorTypes,
  extra?: Record<string, unknown>
): void {
  const control = window.ProctorClient3.giveControl();
  if (source && control && typeof control?.errorCallback === "function") {
    control.errorCallback(e, source);
  }

  Sentry.withScope((scope) => {
    if (source) {
      scope.setTag("error_source", source);
    }
    if (extra) {
      for (const [key, value] of Object.entries(extra)) {
        scope.setExtra(key, value);
      }
    }
    if (!(e instanceof Error)) {
      scope.setExtra("original_error", e);
    }
    Sentry.captureException(toError(e));
  });
}
